module.exports = "<div ng-controller=\"MainCtrl as mainVm\">\r\n    <!-- <div ng-include=\"'header'\"></div> -->\r\n    <div ng-include=\"'menubar'\"></div>\r\n    <div class=\"content_container\">\r\n        <ui-view></ui-view>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./base.html
// module id = 316
// module chunks = 0